export const initEvents = (win, cap) => {
    const doc = win.document;
    const cordova = win.cordova;
    cap.addListener = (pluginName, eventName, callback) => {
        const callbackId = cap.nativeCallback(pluginName, 'addListener', {
            eventName: eventName,
        }, callback);
        return {
            remove: async () => {
                var _a;
                (_a = win === null || win === void 0 ? void 0 : win.console) === null || _a === void 0 ? void 0 : _a.debug('Removing listener', pluginName, eventName);
                cap.removeListener(pluginName, callbackId, eventName, callback);
            },
        };
    };
    cap.removeListener = (pluginName, callbackId, eventName, callback) => {
        cap.nativeCallback(pluginName, 'removeListener', {
            callbackId: callbackId,
            eventName: eventName,
        }, callback);
    };
    cap.createEvent = (eventName, eventData) => {
        if (doc) {
            const ev = doc.createEvent('Events');
            ev.initEvent(eventName, false, false);
            if (eventData && typeof eventData === 'object') {
                for (const i in eventData) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (eventData.hasOwnProperty(i)) {
                        ev[i] = eventData[i];
                    }
                }
            }
            return ev;
        }
        return null;
    };
    cap.triggerEvent = (eventName, target, eventData) => {
        eventData = eventData || {};
        const ev = cap.createEvent(eventName, eventData);
        if (ev) {
            if (target === 'document') {
                if (cordova === null || cordova === void 0 ? void 0 : cordova.fireDocumentEvent) {
                    cordova.fireDocumentEvent(eventName, eventData);
                    return true;
                }
                else if (doc === null || doc === void 0 ? void 0 : doc.dispatchEvent) {
                    return doc.dispatchEvent(ev);
                }
            }
            else if (target === 'window' && win.dispatchEvent) {
                return win.dispatchEvent(ev);
            }
            else if (doc === null || doc === void 0 ? void 0 : doc.querySelector) {
                const targetEl = doc.querySelector(target);
                if (targetEl) {
                    return targetEl.dispatchEvent(ev);
                }
            }
        }
        return false;
    };
};
//# sourceMappingURL=events.js.map